import createRepository from '@/repositories/Repository';

export default {
  install(Vue) {
    Vue.prototype.$repositories = createRepository(Vue.prototype.$http);
  },
};
